export enum WorkflowMultiVariablesEnum {
  OBSERVATION_CATEGORY = 'observation_category',
  RISK_RATING = 'risk_rating',
  TAX = 'tax',
}
